import React from 'react';
import Head from 'next/head';
import Image from 'next/image';

// Utils
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';

// Images
import homeHeadBg from '../public/images/home/home_head.png';

// Services
import faqService from '../src/services/faqService';

// Components
import QuestionsAnswers from '../components/organisms/FAQ/QuestionsAnswers/QuestionsAnswers';

import styles from '../styles/pages/Help.module.scss';
import cn from '../src/utils/cn';
import ContactBanner from '../components/organisms/ContactBanner/ContactBanner';

function Help({ questions }) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>
          {t('help.title')}
        </title>
      </Head>

      <main className={styles.page}>
        <div className={styles.head}>
          <div className={styles.head_bg}>
            <Image src={homeHeadBg} layout="fill" objectFit="cover" alt="Tennis court" priority />
          </div>
          <div className={cn([styles.head_content, 'flex d-col center'])}>
            <h1 className="fs-34 m-b-20">
              {t('help.title')}
            </h1>

            <div className={styles.banner}>
              <p className="fs-16 fw-500 m-b-4">{t('help.question')}</p>
              <p className="fs-14">{t('help.answers')}</p>
            </div>
          </div>
        </div>

        <div className={styles.faq_wrapper}>
          <QuestionsAnswers questions={questions} white />

          <div className="m-t-60">
            <ContactBanner dark />
          </div>
        </div>
      </main>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  const questions = await faqService.getQuestions({ count: null });
  const questionsData = questions ? questions.data : [];

  return {
    props: {
      ...(await serverSideTranslations(
        locale || 'fr',
        ['common'],
      )),
      questions: questionsData?.questions ? questionsData.questions : [],
    },
  };
}

export default Help;
